import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import TokenDistributionModal from "./TokenDistributionModal";

const IndexSections = ({ptgcPrice}) => {

  const [modalStatus, setModalStatus] = useState(false);
  const openModal = () => setModalStatus(true);
  const closeModal = () => setModalStatus(false);
  
  return (
    <>
      <div className="statsSN subcontent" data-aos="fade-up"  data-aos-delay="500" data-aos-duration="600">
        <div className="d-flex justify-content-between gap-1 align-items-end">
          <div>
            <h2 className="gradient-stroke-text">Token Distribution</h2>
            <p>Fair and distributed token allocation to support sustained project growth. View the current token supply distribution, including supply distribution , holder supply % breakdown, and position dollar value.</p>
            <button onClick={openModal}  className="mybtn underline text-white p-0 pt-0"><span>View Now</span></button>
          </div>
          <div>
          </div>
        </div>
      </div>
      <TokenDistributionModal modalIsOpen={modalStatus} closeModal={closeModal} ptgcPrice={ptgcPrice}/>
    </>
  );
};

export default IndexSections;
